import { Navigate, useLocation } from "react-router-dom";

/**
 * A legacy address that moved. Unlike a bare `<Navigate to=… />`, it carries
 * the link's own query and hash across — `/subagents?agent=librarian` used to
 * arrive as `/agents?view=editor` with the agent dropped, so the editor opened
 * on the FIRST agent instead of the one linked (2026-10-02). `add` sets what
 * the new address needs (it wins over a same-named key in the old link).
 * Replace, so the dead address never becomes a Back step.
 */
export function MovedTo({ to, add }: { to: string; add?: Record<string, string> }) {
	const location = useLocation();
	const params = new URLSearchParams(location.search);
	for (const [key, value] of Object.entries(add ?? {})) params.set(key, value);
	const search = params.toString();
	return <Navigate to={`${to}${search ? `?${search}` : ""}${location.hash}`} replace />;
}
